<form>
  <h1 mat-dialog-title>{{ (service.isUpdateServiceAccount? 'Accounts.addServiceAccount.headerEdit' : 'Accounts.addServiceAccount.headerNew') | translate}}</h1>
  <div mat-dialog-content>
    <div class="row">
      <div class="col-6">
        <div class="row">
          <mat-form-field class="col-12">
            <mat-label>{{'Accounts.addServiceAccount.lblName' | translate}}</mat-label>
            <input type="text" matInput [(ngModel)]="serviceAccount.name" [ngModelOptions]="{standalone: true}" required>
          </mat-form-field>
        </div>
      </div>
      <div class="col-6">
        <div class="row">
          <mat-form-field class="col-12">
            <mat-label>{{'Accounts.addServiceAccount.lblKey' | translate}}</mat-label>
            <input type="text" matInput [(ngModel)]="serviceAccount.key" [ngModelOptions]="{standalone: true}" readonly>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row">
    </div>
    <div class="row">
      <mat-form-field class="col-12">
        <mat-label>{{'Accounts.addServiceAccount.lblSecret' | translate}}</mat-label>
        <input type="text" matInput [(ngModel)]="serviceAccount.secret" [ngModelOptions]="{standalone: true}" readonly>
        <button mat-raised-button matSuffix color="basic" (click)="OnGenerateSecret()">{{'Accounts.addServiceAccount.btnGenerate' | translate}}</button>
      </mat-form-field>
    </div>
    <div class="row">
      <div class="col-lg-6 col-md-12">
        <div class="row">
          <mat-form-field class="col-12">
            <mat-label>{{'Accounts.addServiceAccount.lblGenMarkets' | translate}}</mat-label>
            <mat-select multiple [(ngModel)]="serviceAccount.generalMarketIds" [ngModelOptions]="{standalone: true}">
              @for (market of markets; track market) {
                <mat-option [value]="market.id">{{market.value}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <div class="row">
          <mat-checkbox class="pl-3" color="primary" [(ngModel)]="serviceAccount.enabled" [ngModelOptions]="{standalone: true}">
            {{'Accounts.ckbxEnabled' | translate}}
          </mat-checkbox>
        </div>
      </div>
      <mat-form-field class="col-lg-6 col-md-12">
        <mat-label>{{'Accounts.addServiceAccount.lblNotes' | translate}}</mat-label>
        <textarea matInput rows="3" [(ngModel)]="serviceAccount.notes" [ngModelOptions]="{standalone: true}"></textarea>
      </mat-form-field>
    </div>
  </div>
  <div mat-dialog-actions>
    <button mat-raised-button color="primary" (click)="OnSaveServiceAccount()">{{'btnOk' | translate}}</button>&nbsp;
    <button mat-raised-button color="secondary" (click)="OnCancel()">{{'btnCancel' | translate}}</button>
  </div>
</form>
